var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVhand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 94,
    viewBox: "0 0 77 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.6485 80.8316C47.6485 80.8316 48.0963 68.7985 48.0963 68.1269C48.0963 67.4552 48.0963 64.1713 48.0963 64.1713C48.0963 64.1713 48.022 62.8281 47.3503 61.7087C46.6787 60.5893 44.216 55.9621 44.0665 49.4696C43.9169 42.9771 44.0665 44.246 44.0665 44.246C44.0665 44.246 44.0665 40.4401 44.5886 39.3207C45.1106 38.2013 44.8868 37.2672 45.6336 36.0547C46.3796 34.8431 46.9769 32.9768 48.5441 32.7529C50.1112 32.529 51.2306 32.8272 51.5288 33.8723C51.827 34.9174 52.3858 37.3666 53.1327 38.7842C53.1327 38.7842 53.9915 40.141 54.1787 41.1108C54.365 42.0806 54.2163 44.1332 56.567 44.1332",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7158 37.3623C46.7158 37.3623 48.1146 39.9369 49.1785 41.1683C50.2424 42.3996 50.074 43.0148 50.6901 44.4709C51.3063 45.9271 52.2018 47.5497 54.3277 46.9336C56.4537 46.3175 54.6725 43.3748 54.5248 42.893",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5661 45.3664C56.5661 45.3664 57.4338 42.7076 57.5735 41.6724C57.7132 40.6372 56.6404 38.9482 55.7081 38.0903C55.1171 37.5467 53.9261 36.1927 53.0574 34.3721C52.555 33.3199 52.161 32.1118 52.0517 30.8142C51.7535 27.2697 52.6858 26.0008 53.6189 25.7026C54.552 25.4044 55.5595 25.9641 57.201 29.1351C57.201 29.1351 57.8726 30.3288 59.2159 31.7097C60.5592 33.0906 60.6335 33.9861 61.2308 34.9184C61.8281 35.8515 64.0669 39.3216 66.0066 41.2613C67.9472 43.2019 67.6114 44.8434 67.4995 49.7688C67.3875 54.6941 66.2681 57.4926 65.858 58.2762C65.4478 59.0598 65.3726 60.627 65.4845 65.5899C65.5965 70.5529 65.8947 81 65.8947 81",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7076 32.6841C50.7076 32.6841 49.6545 27.5671 51.039 26.8587C52.4235 26.1504 52.676 26.454 52.676 26.454",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8591 26.9124C55.8591 26.9124 55.4086 24.3583 55.1847 22.7169C54.9608 21.0754 55.0728 19.433 54.737 16.0381C54.4011 12.6432 54.1397 11.8587 53.8791 9.99331C53.6176 8.12794 53.5056 7.12048 53.2817 5.55332C53.0579 3.98616 52.4256 1.48587 54.5704 1.07572C56.7152 0.665574 58.0952 1.78497 58.9164 7.82973C59.7376 13.8745 60.5578 14.4718 61.1175 18.6879C61.6772 22.904 61.7892 25.33 61.7892 26.0016C61.7892 26.6733 61.8635 27.6807 63.6922 27.6807C65.5208 27.6807 65.6328 26.7476 66.2292 25.1804C66.8256 23.6133 67.722 20.8891 68.5056 19.0613C69.2892 17.2336 70.1471 14.3599 70.6324 12.3826C71.1178 10.4053 71.4536 5.25601 74.5503 6.07631C77.6471 6.8975 75.5954 12.867 75.222 14.8452C74.8486 16.8225 74.4384 21.2258 73.0208 25.4795C71.6032 29.7333 71.0435 30.7783 70.782 33.3897C70.5205 36.0019 69.8489 39.8822 69.9241 41.5613C69.9993 43.2404 68.9936 47.1959 67.5931 49.2108",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9609 73.9492L31.4062 52.5625H37.9297L28.0273 81H21.9141L12.0508 52.5625H18.5547L24.9609 73.9492Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2424 69.8929) rotate(88.0754) scale(45.1147 45.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVhand);
export default __webpack_public_path__ + "static/media/Vhand.109d8cc88c75f20b1530b23d560123ba.svg";
export { ForwardRef as ReactComponent };